import client from './client';

export async function getOrderDiscountList() {
  const res = await client.get('/admin/order-discount');
  return res.data;
}

export async function getOrderDiscount(discountId) {
  const res = await client.get(`/admin/order-discount/${discountId}`);
  return res.data;
}

export async function createOrderDiscount(payload) {
  const res = await client.post('/admin/order-discount', payload);
  return res.data;
}

export async function updateOrderDiscount(discountId, payload) {
  const res = await client.put(`/admin/order-discount/${discountId}`, payload);
  return res.data;
}

export async function deleteOrderDiscount(discountId) {
  const res = await client.delete(`/admin/order-discount/${discountId}`);
  return res.data;
}
